<template>
 <svg
  role="img"
  xmlns="http://www.w3.org/2000/svg"
  width="10.1667"
  height="11.6111"
  viewBox="0 0 10.1667 11.6111"
  fill="none"
  aria-label="An icon of the outline of a chair"
 >
  <path d="M1.99408 0.5H8.17309L8.6484 6.61111H1.51877L1.99408 0.5Z" stroke="currentColor" />
  <line x1="1.91667" y1="8.61111" x2="1.91667" y2="11.6111" stroke="currentColor" />
  <line x1="8.33333" y1="8.61111" x2="8.33333" y2="11.6111" stroke="currentColor" />
  <rect x="0.5" y="6.61111" width="9.16667" height="2.22222" stroke="currentColor" />
 </svg>
</template>
